import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useUser } from '../../services/redux-services/UserInfoContext';
import { useLanguage } from '../../services/language/LanguageContext';
import ImageViewer from '../image-viewer/ImageViewer';

const AVATAR_COLORS = ['#1e3a5f', '#7c3aed', '#0891b2', '#059669', '#d97706', '#dc2626'];
const getAvatarColor = (str = '') => AVATAR_COLORS[(str.charCodeAt(0) || 0) % AVATAR_COLORS.length];

const TopbarUserProfile = () => {
    const { user } = useUser();
    const { t } = useLanguage();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const navigate = useNavigate();

    const initials = `${(user?.firstName || '')[0] || ''}${(user?.lastName || '')[0] || ''}`.toUpperCase() || '?';
    const color = getAvatarColor(user?.firstName || '');
    const fullName = `${user?.firstName || '-'} ${user?.lastName || ''}`.trim();

    useEffect(() => {
        const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const handleLogout = () => {
        setOpen(false);
        navigate('/auth/login');
    };

    return (
        <li style={{ listStyle: 'none', position: 'relative' }} ref={ref}>
            <button
                onClick={() => setOpen(o => !o)}
                style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    background: open ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.08)',
                    borderRadius: 10, padding: '5px 10px 5px 6px',
                    cursor: 'pointer', transition: 'background 0.15s',
                    border: 'none',
                }}
            >
                {user?.image ? (
                    <div style={{ width: 30, height: 30, borderRadius: '50%', overflow: 'hidden', flexShrink: 0, border: '2px solid rgba(255,255,255,0.3)' }}>
                        <ImageViewer id={user.image} width={30} preview={false} />
                    </div>
                ) : (
                    <div style={{
                        width: 30, height: 30, borderRadius: '50%', flexShrink: 0,
                        background: `linear-gradient(135deg, ${color}cc, ${color})`,
                        border: '2px solid rgba(255,255,255,0.3)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 11, fontWeight: 700, color: '#fff',
                    }}>
                        {initials}
                    </div>
                )}
                <span style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.92)', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {fullName}
                </span>
                <i className="fa fa-chevron-down" style={{ fontSize: 9, color: 'rgba(255,255,255,0.6)', transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            </button>

            {open && (
                <div style={{
                    position: 'absolute', top: 'calc(100% + 8px)', right: 0,
                    minWidth: 240, background: '#fff',
                    borderRadius: 14, boxShadow: '0 8px 32px rgba(0,0,0,0.14)',
                    border: '1px solid #f0f0f0',
                    zIndex: 9999, overflow: 'hidden',
                }}>
                    <div style={{ padding: '16px 16px 12px', background: 'linear-gradient(135deg, #1e3a5f, #2d6a9f)' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            {user?.image ? (
                                <div style={{ width: 44, height: 44, borderRadius: '50%', overflow: 'hidden', flexShrink: 0, border: '2px solid rgba(255,255,255,0.4)' }}>
                                    <ImageViewer id={user.image} width={44} preview={false} />
                                </div>
                            ) : (
                                <div style={{
                                    width: 44, height: 44, borderRadius: '50%', flexShrink: 0,
                                    background: `linear-gradient(135deg, ${color}bb, ${color})`,
                                    border: '2px solid rgba(255,255,255,0.4)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    fontSize: 16, fontWeight: 700, color: '#fff',
                                }}>
                                    {initials}
                                </div>
                            )}
                            <div style={{ minWidth: 0 }}>
                                <div style={{ fontSize: 14, fontWeight: 700, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {fullName}
                                </div>
                                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', marginTop: 1 }}>
                                    {user?.userType?.name || t('administrator')}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ padding: '6px 0' }}>
                        {/* <DropdownLink to="/settings" icon="fa-user" label={t('profile')} onClick={() => setOpen(false)} /> */}
                        <DropdownLink to="/settings" icon="fa-cog" label={t('settings')} onClick={() => setOpen(false)} />
                    </div>

                    <div style={{ borderTop: '1px solid #f3f4f6', padding: '6px 0' }}>
                        <button
                            onClick={handleLogout}
                            style={{
                                display: 'flex', alignItems: 'center', gap: 10,
                                width: '100%', padding: '9px 16px',
                                background: 'none', border: 'none', cursor: 'pointer',
                                textAlign: 'left', transition: 'background 0.1s',
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = '#fef2f2'}
                            onMouseLeave={e => e.currentTarget.style.background = 'none'}
                        >
                            <span style={{ width: 28, height: 28, borderRadius: 8, background: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <i className="fa fa-sign-out" style={{ fontSize: 12, color: '#dc2626' }} />
                            </span>
                            <span style={{ fontSize: 13, fontWeight: 600, color: '#dc2626' }}>{t('logout')}</span>
                        </button>
                    </div>
                </div>
            )}
        </li>
    );
};

const DropdownLink = ({ to, icon, label, onClick }) => (
    <Link
        to={to}
        onClick={onClick}
        style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 16px', textDecoration: 'none', transition: 'background 0.1s' }}
        onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
        onMouseLeave={e => e.currentTarget.style.background = 'none'}
    >
        <span style={{ width: 28, height: 28, borderRadius: 8, background: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <i className={`fa ${icon}`} style={{ fontSize: 12, color: '#4f46e5' }} />
        </span>
        <span style={{ fontSize: 13, fontWeight: 500, color: '#374151' }}>{label}</span>
    </Link>
);

export default TopbarUserProfile;
